export const SET_SSO = "setSSO";
export const CLEAR_SSO = "clearSSO";
export const ADD_GROUP = "addGroup";
export const REMOVE_GROUP = "removeGroup";
export const SET_GROUP_NAME = "setGroupName";
export const SET_GROUP_TEAM = "setGroupTeam";
export const SET_DEFAULT = "setDefault";
